export const reportTitle = {
  receive: 'Поступило заявок',
  complete: 'Выполнено',
  annulled: 'Аннулировано',
  period: 'Сроки выполнения',
};
